import React from 'react';

function YoutubePlayer(props) {
    return ( 
        <div>
            <h2>id: {props.id}</h2>
            <iframe width="560" 
                    height="315" 
                    src={"https://www.youtube.com/embed/" + props.id} 
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>

            </iframe>
        </div>
     );
}

export default YoutubePlayer;